const styles = {
    container: {
        minHeight: '100vh',
        color: '#0c0c0c',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    },
    header: {
        marginBottom: '24px'
    },
    title: {
        color: '#124b04',
        fontSize: '28px',
        fontWeight: 'bold',
        margin: '0 0 8px 0',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',

    },
    subtitle: {
        color: '#666',
        fontSize: '14px'
    },
    couponCodeDisplay: {
        background: '#fff',
        padding: '20px',
        borderRadius: '12px',
        border: '2px dashed rgb(251, 121, 116)',
        marginBottom: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    },
    couponCodeTxt: {
        textAlign: 'left',
    },
    couponCode: {
        fontSize: '24px',
        fontWeight: 'bold',
        color: '#124b04',
        letterSpacing: '2px',
        margin: '8px 0'
    },
    copyButton: {
        backgroundColor: 'rgb(251, 121, 116)',
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        transition: 'all 0.3s ease',
        marginTop: '12px'
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '16px',
        marginBottom: '24px'
    },
    card: {
        background: '#fff',
        borderRadius: '12px',
        padding: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        transition: 'transform 0.2s ease'
    },
    cardIcon: {
        fontSize: '24px',
        marginBottom: '12px'
    },
    cardTitle: {
        fontSize: '14px',
        color: '#666',
        marginBottom: '8px',
        fontWeight: '500'
    },
    cardValue: {
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#124b04'
    },
    highlightValue: {
        color: 'rgb(251, 121, 116)'
    },
    performanceGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '16px',
        marginBottom: '24px'
    },
    performanceCard: {
        background: 'linear-gradient(135deg, #124b04, #1a6b06)',
        color: 'white',
        borderRadius: '12px',
        padding: '24px',
        boxShadow: '0 4px 12px rgba(18, 75, 4, 0.3)'
    },
    progressBar: {
        width: '100%',
        height: '8px',
        backgroundColor: 'rgba(255,255,255,0.3)',
        borderRadius: '4px',
        margin: '16px 0 8px 0',
        overflow: 'hidden'
    },
    progressFill: {
        height: '100%',
        backgroundColor: 'white',
        borderRadius: '4px',
        transition: 'width 0.5s ease'
    },
    tableCard: {
        background: '#fff',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        marginBottom: '24px'
    },
    tableHeader: {
        background: '#124b04',
        color: 'white',
        padding: '16px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse'
    },
    th: {
        background: '#124b04',
        color: 'white',
        padding: '12px',
        textAlign: 'left',
        fontSize: '14px',
        fontWeight: '600'
    },
    td: {
        padding: '12px',
        borderBottom: '1px solid #f0f0f0',
        fontSize: '14px',
        whiteSpace: 'nowrap'
    },
    image: {
        width: '110px',
    },
    tr: {
        transition: 'background-color 0.2s ease'
    },
    tag: {
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: '500',
        whiteSpace: 'nowrap'
    },
    rewardTag: {
        backgroundColor: 'rgb(251, 121, 116)',
        color: 'white'
    },
    discountTag: {
        backgroundColor: '#124b04',
        color: 'white'
    },
    statusCompleted: {
        color: '#52c41a',
        fontWeight: '500',
        whiteSpace: 'nowrap'
    },
    statusPending: {
        color: '#faad14',
        fontWeight: '500',
        whiteSpace: 'nowrap'
    },
    statusCancelled: {
        color: 'red',
        fontWeight: '500',
        whiteSpace: 'nowrap'
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        marginTop: '16px',
        padding: '16px'
    },
    pageButton: {
        padding: '8px 12px',
        border: '1px solid #d9d9d9',
        background: 'white',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px'
    },
    activePageButton: {
        backgroundColor: '#124b04',
        color: 'white',
        border: '1px solid #124b04'
    },
    summaryCard: {
        background: '#fff',
        borderRadius: '12px',
        padding: '24px',
        marginBottom: '30px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'center'
    },
    summaryGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '24px',
        alignItems: 'center'
    },
    avatar: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        backgroundColor: '#124b04',
        color: 'white',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        fontWeight: '600',
        marginRight: '8px'
    }
};

const mobileStyles = `
 @media(max-width:992px) {
 .coupon-code-display{
      >div{
      text-align: center !important;
      }
 }
          .table-wrapper {
        overflow-x: auto;
    }
    
    @media (max-width: 768px) {
      .dashboard-container {
        padding: 12px !important;
      }
    .dashboard_title{
        font-size: 20px !important;
    }
      .coupon-code {
        font-size: 18px !important;
      }
      .table-wrapper {
        overflow-x: auto;
      }
      .card-grid {
        grid-template-columns: 1fr  1fr!important;
      }
      .performance-grid {
        grid-template-columns: 1fr 1fr !important;
      }
      .summary-grid {
        grid-template-columns: 1fr 1fr !important;
      }
      .table-responsive {
        font-size: 12px;
      }
      .table-responsive td, .table-responsive th {
        padding: 8px 4px;
      }
    }
    @media (max-width: 576px) {
      .coupon-code-display {
        padding: 16px !important;
      }
      .card {
        padding: 16px !important;
      }

     
      .coupon-code {
        font-size: 16px !important;
      }
     
      .card-grid {
        grid-template-columns:  1fr!important;
      }
      .performance-grid {
        grid-template-columns: 1fr !important;
      }
      .summary-grid {
        grid-template-columns: 1fr !important;
      }
    }
  `;

export { styles, mobileStyles }